import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  FormHelperText,
  Tabs,
  Tab,
  FormControlLabel,
  InputAdornment,
  Select,
  MenuItem
} from "@mui/material";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import {
  button_bg_color_for_New_Project,
  hoveredSettings_Nav_bg_dm,
  selecetedSettings_Nav_bg_dm,
  settingsModal_bg_color_dm,
  uploadFiles_button_default_bg_color,
  uploadFiles_button_hovered_bg_color,
} from "../../../../../constants/colors";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import sourceUrl from "../../../../../api/Source.api";
import * as Sentry from "@sentry/react";
import { AddContactAgentForCallingAgent, UpdateContactAgentbyIdForCallingAgent, uploadContactsCSVFile } from "../../../../../contexts/WorkspaceUtils";
import { ToggleSwitch } from "../../../../Common_Components/ToggleSwitch";
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import sampleCSV from '../../../../../assets/SampleCSVFIle/Sample_CSV_file.csv'
import CommonToast from "../../../../Common_Components/CommonToast";
import CircularProgress from '@mui/material/CircularProgress';
import GetCountryFlagByName from "../../../settingBar/VideoGenSettings/GetCountryFlagByName";
import { countryDatas } from "../../../../../constants/countryList";
import { customTextFieldStyles, customTextFieldStylesForInvalid } from "../../../../../constants/FormInputBoxCss";

  const userEmail = localStorage.getItem("userEmail");

const ModalForContacts = ({ openAddAgentModal, setOpenAddAgentModal, handleClose, fetchData, activeUserObject, setMoreActionOption, ButtonClick }) => {
  const theme = localStorage.getItem("theme");
  const token = localStorage.getItem("token");
  const [window, setWindow] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progressStatusChecking, setProgressStatusChecking] = useState({});
  const [fileUploaded, setFileUploaded] = useState(false);
  const [notificationToastMessage, setNotificationToastMessage] = useState("");
    const [toastopen, setToastopen] = useState(false);
    const [content, setContent] = useState("");
    const [iconType, setIconType] = useState('success');
    const [customAttributesError, setCustomAttributesError] = useState(false);
    const [batchCount, setBatchCount] = useState("100");
    const [uploading, setUploading] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [contactId, setContactId] = useState("phone");
    const [delimiter, setDelimiter] = useState(",");
    const [instantCall, setInstantCall] = useState(false);
    const [allFilterCountry, setAllFilterCountry] = useState(countryDatas);
    const [selectedCountry, setSelectedCountry] = useState(
              countryDatas.find((country) => country.name === "Canada")
            );
    const [addContactData, setAddContactData] = useState({
      name:"",
      email:"",
       phone:{
        country_code: "",
        number: "",
        e164: ""
      },
      country:"",
      custom_attributes: ""
    })
  const fileInputRef = useRef(null);

  console.log("addContactData", addContactData)

  function convertObjectToTextFormat(input) {
    try {
      // If input is a string that looks like JSON, try to parse it
      if (typeof input === "string" && input.trim().startsWith("{")) {
        input = JSON.parse(input);
      }
  
      if (input && typeof input === "object" && !Array.isArray(input)) {
        const keys = Object.keys(input);
        if (keys.length > 0) {
          const entries = keys.map(
            (key) => `"${key}":"${String(input[key])}"`
          );
          return `{${entries.join(",")}}`;
        } else {
          return ""; // Empty object -> render nothing
        }
      } else {
        return String(input); // Primitive values or non-object input
      }
    } catch (e) {
      return String(input); // If parsing fails, return original string
    }
  }

    useEffect(() => {
      if (!openAddAgentModal) {
        setAddContactData({
        name:"",
        email:"",
        phone:{
        country_code: "",
        number: "",
        e164: ""
      },
      country: "",
      custom_attributes: ""
        });
      }
    }, [openAddAgentModal]);

      useEffect(()=>{
        if(activeUserObject){
        // let mobileNumber = activeUserObject?.phone?.slice(2);
        // let countryCode = activeUserObject?.phone?.slice(0,2);
        //   // setAddContactData(activeUserObject)
        //   if(countryCode == "+2"){
        //       setSelectedCountry( { id: 108, name: "Mauritius", code: "MU", mobileCode: "+230" },)
        //        mobileNumber = activeUserObject?.phone?.slice(4);
        //   }else if(countryCode == "+1"){
        //     setSelectedCountry( { id: 32, name: "Canada", code: "CA", mobileCode: "+1" },)
        //         mobileNumber = activeUserObject?.phone?.slice(2);
        //   }else{
        //       setSelectedCountry( { id: 32, name: "Canada", code: "CA", mobileCode: "+1" },)
        //        mobileNumber = activeUserObject?.phone
        //   }

          const userCountryObject = countryDatas.filter((countryObject, index)=>countryObject?.code === activeUserObject?.country)
          setSelectedCountry(userCountryObject[0])
          setAddContactData(prev => ({ ...prev,
          name:activeUserObject?.name,
          phone:{...prev.phone,
                  country_code: activeUserObject?.phone?.country_code,
                  number: activeUserObject?.phone?.number,
                  e164: activeUserObject?.phone?.e164
                },
          email:activeUserObject?.email, 
          country: activeUserObject?.country,
          custom_attributes : convertObjectToTextFormat(activeUserObject?.custom_attributes) }))
        }else{
        setAddContactData({
        name:"",
        phone:{
          country_code: "",
          number:"",
          e164:""
        },
        email:"",
        country:"",
        custom_attributes: ""
          })
        }
      },[activeUserObject])

  useEffect(() => {
    if (ButtonClick === "upload") {
      setWindow(2);
    }
    return () => {
      setWindow(1);
    };
  }, [ButtonClick]);

  const handleToastClose = () => {
    setToastopen(false);
  };

  const handleUpdateContact =async () => {
    const isValidJson = validateJson(addContactData?.custom_attributes);
    // if (!isValidJson.success) {
    //   setCustomAttributesError(true);
    //   return;
    // }
    // await setAddContactData(prev => ({ ...prev, custom_attributes :  convertJsonTextToSimpleText(addContactData?.custom_attributes) }))
    if(addContactData?.name === ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    if(addContactData?.email === ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    if(addContactData?.phone?.number === ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    const newObj = {
      name:addContactData?.name,
      email:addContactData?.email,
      phone:{...addContactData?.phone,
        country_code: selectedCountry.mobileCode,
        number: addContactData?.phone?.number,
        e164:  `${selectedCountry.mobileCode}${addContactData?.phone?.number}`,
      },
      country: selectedCountry?.code,
      custom_attributes: addContactData?.custom_attributes
    }
    setLoading(true)
    try{
      const jsonResponse = await UpdateContactAgentbyIdForCallingAgent(activeUserObject?.id ,newObj);
          const Response =await jsonResponse.json()
          if(Response?.status){
            setOpenAddAgentModal(false)
            handleClose()
            setToastopen(true)
            setContent(Response?.message)
            setIconType('success')
            await fetchData()
          }else{
            setToastopen(true)
            setContent(Response?.message)
            setIconType('error')
          }
    }catch(error){
      console.error("API Error:", error);
      setToastopen(true)
      setContent(error?.message)
      setIconType('error')
    }finally{
    setLoading(false)
    }
  }

const isValidPhone = (phone) => {
  const cleaned = phone.replace(/[\s\-().]/g, ''); // Remove spaces, dashes, parentheses, etc.
  return /^\+?[1-9]\d{1,14}$/.test(cleaned); // E.164 format: optional +, 1–15 digits, cannot start with 0
};


function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}


  const handleAddContact =async () => {
   
    const isValidJson = validateJson(addContactData?.custom_attributes);
    // if (!isValidJson.success) {
    //   setCustomAttributesError(true);
    //   return;
    // }
    if(addContactData?.name == ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    if(addContactData?.email == ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    if(addContactData?.phone == ""){
      setToastopen(true)
      setContent("Please fill in all required fields.")
      setIconType('error')
      return
    }
    if(!isValidPhone(`${selectedCountry.mobileCode}${addContactData?.phone?.number}`)){
      setToastopen(true)
      setContent("Please fill Valid Phone Number")
      setIconType('error')
      return
    }
     if(!isValidEmail(`${addContactData?.email}`)){
      setToastopen(true)
      setContent("Please fill Valid Email id")
      setIconType('error')
      return
    }
    // const newObj = {
    //   name:addContactData?.name,
    //   phone:`${selectedCountry.mobileCode}${addContactData?.phone}`,
    //   email:addContactData?.email,
    //   custom_attributes: addContactData?.custom_attributes
    // }

     const newObj = {
      name:addContactData?.name,
      email:addContactData?.email,
      phone:{
        country_code: selectedCountry.mobileCode,
        number: addContactData?.phone?.number,
        e164:  `${selectedCountry.mobileCode}${addContactData?.phone?.number}`,
      },
      country: selectedCountry?.code,
      custom_attributes: addContactData?.custom_attributes
    }
     setLoading(true)
     try{
          const jsonResponse = await AddContactAgentForCallingAgent(newObj);
          const Response = await jsonResponse.json()
          if(Response?.status){
            setOpenAddAgentModal(false)
            setToastopen(true)
            setContent(Response?.message)
            setIconType('success')
            await fetchData()
          }else{
            setToastopen(true)
            setContent(Response?.error?.message)
            setIconType('error')
          }
        }catch(error){
          console.error("API Error:", error);
          setToastopen(true)
          setContent(error?.message)
          setIconType('error')
        }finally{
          setLoading(false)
        }
  }

  const validateJson = (str) => {
    try {
      const parsed = JSON.parse(str);
      if (typeof parsed === 'object' && parsed !== null) {
        return { success: true, data: parsed };
      } else {
        return { success: false };
      }
    } catch (err) {
      return { success: false };
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setToastopen(true);
      setContent("Please select a file first");
      setIconType('error')
      return;
    }

    // console.log("file", file)
  
    const formData = new FormData();
    formData.append("trigger_call", instantCall);
    // formData.append("trigger_call", instantCall);
    formData.append( "file", file);
  
    try {
        setLoading(true)
      const response = await axios.post(
        `${sourceUrl}/callingAgent/contacts/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            "Content-Type" : "multipart/form-data"
          },
        }
      );
  
      // console.log("Upload response:", response.data);

      setToastopen(true)
      setContent(response?.data?.message)
      setIconType('sucess')
      setFile(null);
      setFileName(null)
      setBatchCount("100");
      setContactId(",")
      handleClose()
      fetchData()
    } catch (error) {
      console.error("Upload error:", error);
      setIconType('error')
      setContent(error?.response?.data?.message)
      setToastopen(true)
    }finally{
      setLoading(false)
      }
  };
  
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.toLowerCase().endsWith(".csv")) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      console.log("CSV file selected:", selectedFile);
    } else {
      alert("Please select a valid .csv file.");
      // Optional: clear the input if an invalid file is selected
      e.target.value = null;
    }
  };

  const handleFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const HandleDownloadSampleFile =async () => {
    const link = document.createElement('a');
    link.href = sampleCSV;
    link.setAttribute('download', 'sample.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

    const handleCountryCodeChange = (country) => {
    setSelectedCountry(country);
  };

  return (
    <div>
      <Modal
        open={openAddAgentModal}
        onClose={handleClose}
        aria-labelledby="audio-settings-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "640px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
          }}
        >
          <Typography
            id="audio-settings-title"
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "68px",
              borderBottom: `1px solid ${theme === "dark" ? "#535774" : ""}`,
              padding: "20px",
              font: "Inter",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            {window === 1 ? "Add contact" : "Upload contacts"}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: "#FFFFFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding:
                window === 2 ? "20px 40px 0px 40px" : "20px 40px 20px 40px",
            }}
          >
            {window === 1 && (
              <Box
              // sx={{ overflow : ((isHeightUnder700px && window ===1) || (isHeightUnder600px) && window===0) ? "scroll" : "",height: ((isHeightUnder700px && window ===1) || (isHeightUnder700px) && window===0) ? "330px" : "", }}
              >
                <Box sx={{ marginBottom: 3 }}>
                  <TextField
                    type="text"
                    onChange={(e)=>{setCustomAttributesError(false); setAddContactData(prev => ({ ...prev, name: e.target.value }))}}
                    value={addContactData?.name}
                    id="outlined-basic"
                    label="Name*"
                    placeholder="ModalX"
                    variant="outlined"
                    sx={customTextFieldStyles(false)}
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "56px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "16px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                    }}
                  />
                  <FormHelperText
                    sx={{
                      color:
                        "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "16px",
                      margin: "4px 0px 0px 16px",
                      alignSelf: "start",
                    }}
                  >
                  </FormHelperText>
                </Box>

                {/* <Box sx={{ marginBottom: 3 }}>
                  <TextField
                    type="text"
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    // onChange={(e)=>{setAddContactData(prev => ({ ...prev, phone: e.target.value }))}}
                    onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, '');
                              setAddContactData(prev => ({ ...prev, phone: onlyNums }));
                            }}
                    value={addContactData?.phone?.replace(/^\+1/, '')}
                    id="outlined-basic"
                    label="Phone*"
                    placeholder="1234567890"
                    variant="outlined"
                    sx={{
                      ...customTextFieldStyles(false),
                      '& input[type=number]': {
                        MozAppearance: 'textfield',
                      },
                      '& input[type=number]::-webkit-outer-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                      '& input[type=number]::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                      },
                    }}
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "56px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                    }}
                     InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <Typography
                                              sx={{
                                                color: "rgba(255, 255, 255, 0.8)", 
                                                fontWeight: 500,
                                                fontSize: "16px",
                                                alignItems:"center"
                                              }}
                                            >
                                              +1
                                            </Typography>
                                          </InputAdornment>
                                        ),
                                      }}
                  />
                  <FormHelperText
                    sx={{
                      color:
                        "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "16px",
                      margin: "4px 0px 0px 16px",
                      alignSelf: "start",
                    }}
                  >
                    {`Mapped to phone. Duplicate value in custom attribute will be replaced.`}
                  </FormHelperText>
                </Box> */}



                <Box sx={{ marginBottom: 3 }}>
                              <TextField
                                          type="text"
                                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                           onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/\D/g, '');
                                                  setAddContactData(prev => ({ ...prev, phone: {
                                                                                                ...prev.phone,
                                                                                                number: onlyNums,   // ✅ update only number
                                                                                              },
                                                                                            }));
                                                }}
                                          value={addContactData?.phone?.number}
                                          label="Phone number*"
                                          variant="outlined"
                                          placeholder="1234567890"
                                          InputProps={{
                                              startAdornment: (
                                              <InputAdornment position="start" sx={{ padding: "0px"}}>
                                                  <Select
                                                  value={selectedCountry?.id || ''}
                                                  variant="standard"
                                                  style={{ width: '80px', height: "100px", padding: "0px", }}
                                                  renderValue={(selectedId) => {
                                                      const country = countryDatas.find(c => c.id === selectedId);
                                                      return (
                                                      <Box sx={{ display: "flex", flexDirection: "row", columnGap: "10px", alignItems: "center", textAlign: "center" }}>
                                                          <GetCountryFlagByName countryName={country?.name} />
                                                          <p style={{ margin: "0px", color: "rgba(255, 255, 255, 0.80)" }}>{country?.mobileCode}</p>
                                                      </Box>
                                                      );
                                                  }}
                                                  sx={{
                                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                      },
                                                      '&:hover:not(.Mui-disabled):before': {
                                                      border: 'none',
                                                      },
                                                      '&::before': {
                                                      borderBottom: 'none',
                                                      },
                                                      '&::after': {
                                                      borderBottom: 'none',
                                                      },
                                                      color: "rgba(255, 255, 255, 0.80)",
                                                      '& .MuiSvgIcon-root': {
                                                      color: '#CAC4D0', // Dropdown icon color
                                                      },
                                                    }}
                                                    MenuProps={{
                                                      PaperProps: {
                                                        sx: {
                                                          backgroundColor: '#282D51',
                                                          color: 'white',
                                                        },
                                                      },
                                                    }}
                                                  SelectProps={{
                                                      MenuProps: {
                                                      PaperProps: {
                                                          sx: {
                                                          bgcolor: '#282D51',
                                                          padding: "0px",
                                                          '& .MuiMenuItem-root.Mui-selected': {
                                                              bgcolor: '#282D51',
                                                              color: 'white',
                                                              '&:hover': {
                                                              bgcolor: '#393F69',
                                                              },
                                                          },
                                                          },
                                                      },
                                                      onClose: (event) => {
                                                          if (event?.target?.id === "search-country-input") {
                                                          event.stopPropagation();
                                                          }
                                                      }
                                                      },
                                                  }}
                                                  >
                                                  <Box sx={{ border: "", height: "200px", width: "200px", overflowX: "hidden", overflowY: "scroll", color: "#282D51", bgcolor: "#282D51", padding: "0px",scrollbarWidth: "none", "&::-webkit-scrollbar": {display: "none" } }}>
                                                      {allFilterCountry.map((country) => (
                                                      <MenuItem
                                                          onClick={() => handleCountryCodeChange(country)}
                                                          key={country?.id}
                                                          value={country}
                                                          sx={{
                                                          // bgcolor: country?.id === selectedCountry?.id ? "#373E6D" : '#282D51',
                                                          marginTop: '-8px',
                                                          marginBottom: '-8px',
                                                          width: '200px',
                                                          height: '56px',
                                                          '&:hover': {
                                                              bgcolor: '#393F69'
                                                          },
                                                          "&.Mui-selected": {
                                                              backgroundColor: "#373E6D !important",
                                                              color: "white",
                                                          },
                                                          }}
                                                      >
                                                          <Box sx={{ display: 'flex' }}>
                                                          <Box sx={{
                                                              display: 'flex',
                                                              flexDirection: "row",
                                                              width: '24px',
                                                              height: '24px',
                                                              marginRight: '12px',
                                                              columnGap: "10px"
                                                          }}>
                                                              <GetCountryFlagByName countryName={country?.name} />
                                                              <Typography sx={{
                                                              display: 'block',
                                                              color: "white",
                                                              fontFamily: 'Inter',
                                                              fontSize: '14px',
                                                              textAlign: 'left',
                                                              opacity: '80%'
                                                              }}>{country.name} </Typography>
                                                              <Typography component='span'
                                                              sx={{
                                                                  color: "white",
                                                                  fontFamily: 'Inter',
                                                                  fontSize: '14px',
                                                                  textAlign: 'left',
                                                                  opacity: '80%',
                                                                  marginLeft: '5px'
                                                              }}>{country.mobileCode}</Typography>
                                                          </Box>
                                                          </Box>
                                                      </MenuItem>
                                                      ))}
                                                  </Box>
                                                  </Select>
                                              </InputAdornment>
                                              )
                                          }}
                                          sx={{
                                              ...customTextFieldStyles(false),
                                                  '& input[type=number]': {
                                                    MozAppearance: 'textfield',
                                                  },
                                                  '& input[type=number]::-webkit-outer-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                                  '& input[type=number]::-webkit-inner-spin-button': {
                                                    WebkitAppearance: 'none',
                                                    margin: 0,
                                                  },
                                              width: "100%",
                                              maxWidth: "100%",
                                              height: "56px",
                                              marginTop:"20px",
                                              color: "#FFFFFF",
                                              backgroundColor: "#232746",
                                              borderRadius: "8px",
                                              marginBottom:"5px",
                                              boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                                              '& .MuiInputLabel-root': {
                                              color: 'rgba(255, 255, 255, 0.80)', // Label text color
                                              fontFamily: 'Inter',
                                              fontSize: '16px',
                                              fontWeight: 400,
                                              },
                                              '& .MuiOutlinedInput-root': {
                                              '& input': {
                                                  color: "white",
                                                  fontFamily: 'Inter',
                                                  fontSize: '16px',
                                                  fontWeight: 400,
                                                  cursor: "text", 
                                              },
                                              '& input::placeholder': {
                                                  color: "rgba(255, 255, 255, 0.40)",
                                                  opacity: 1,
                                              },
                                              '& fieldset': {
                                                  border: "2px solid rgba(255, 255, 255, 0.60)", 
                                              },
                                              '&:hover fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.60)", 
                                              },
                                              '&.Mui-focused fieldset': {
                                                  borderColor: "rgba(255, 255, 255, 0.80)", 
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 0.80)',
                                              }
                                              },
                                              '& .MuiInputLabel-root.Mui-focused': {
                                                  color: 'rgba(255, 255, 255, 1)', 
                                              },
                                          }}  
                                      />
                    <FormHelperText
                    sx={{
                      color:
                        "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "16px",
                      margin: "4px 0px 0px 16px",
                      alignSelf: "start",
                    }}
                  >
                    {`Mapped to phone. Duplicate value in custom attribute will be replaced.`}
                  </FormHelperText>
                </Box>

                <Box sx={{ marginBottom: 3 }}>
                  <TextField
                    type="email"
                    onChange={(e)=>{setAddContactData(prev => ({ ...prev, email: e.target.value }))}}
                    value={addContactData?.email}
                    id="outlined-basic"
                    label="Email*"
                    placeholder="support@modalx.ai"
                    variant="outlined"
                    sx={customTextFieldStyles(false)}
                    // sx={{...customTextFieldStyles(false),mt:5}}
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "56px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                    }}
                  />
                  <FormHelperText
                    sx={{
                      color:
                        "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "16px",
                      margin: "4px 0px 0px 16px",
                      alignSelf: "start",
                    }}
                  >
                    {`Mapped to email. Duplicate value in custom attribute will be replaced.`}
                  </FormHelperText>
                </Box>

                <Box sx={{}}>
                  <TextField
                    type="text"
                    onChange={(e)=>{setAddContactData(prev => ({ ...prev, custom_attributes : e.target.value }))}}
                    value={addContactData?.custom_attributes}
                    id="outlined-basic"
                    label="Contact attributes (optional)"
                    placeholder={`{"nationality" : "Canada"}`}
                    variant="outlined"
                    sx={customTextFieldStylesForInvalid()}
                    multiline
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "112px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                    }}
                    InputProps={{
                      style: {
                        height: "112px", // Ensures the input field fills the container height
                        padding: "20px 14px", // Adjust padding for better alignment
                        alignItems: "flex-start", // Ensures text starts from the top
                        overflow: "auto",
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        whiteSpace: "normal", // Allows label text to wrap
                        // overflow: "visible", // Ensures the entire label is visible
                      },
                    }}
                  />
                  <FormHelperText
                                    sx={{
                                      color:
                                        "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                                      fontFamily: "Inter",
                                      fontSize: "12px",
                                      fontStyle: "normal",
                                      fontWeight: 400,
                                      lineHeight: "16px",
                                      margin: "4px 0px 0px 16px",
                                      alignSelf: "start",
                                    }}
                                  >
                                    {/* {customAttributesError &&  `Invalid JSON format. Please correct it.`} */}
                  </FormHelperText>
                </Box>
              </Box>
            )}

            {window === 2 && (
              <Box onClick={(event) => event.stopPropagation()} sx={{}}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: 5,
                    columnGap: "12px",
                  }}
                >
                  <Box
                    sx={{
                      border: "",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      marginTop: "20px",
                      width: "258px",
                      borderRadius: "8px",
                      bgcolor: isDragging ? "#2C2D4B" : "#1A1E35", // Change color on drag
                      outline: isDragging ? "1px solid #FFF" : "",
                      padding: "20px",
                      rowGap: "24px",
                    }}
                    // onDragEnter={handleDragEnter}
                    // onDragLeave={handleDragLeave}
                    // onDragOver={handleDragOver}
                    // onDrop={handleDrop}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "normal",
                          letterSpacing: "0.1px",
                          textAlign: "left",
                          color: "#ffffff",
                          textTransform: "none",
                        }}
                      >
                        Select files or drop to upload
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: 400,
                          lineHeight: "normal",
                          letterSpacing: "0.1px",
                          textAlign: "left",
                          color: "#ffffff",
                          opacity: "0.8",
                        }}
                      >
                        File should not exceed 5MB
                      </Typography>
                    </Box>
                    <Box>
                      <Button
                        onClick={handleFileSelect}
                        variant="contained"
                        sx={{
                          backgroundColor:
                            theme === "dark"
                              ? uploadFiles_button_default_bg_color
                              : "",
                          color: "black",
                          width: "100%",
                          height: "40px",
                          borderRadius: "8px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "0px",
                          "&:hover": {
                            backgroundColor:
                              uploadFiles_button_hovered_bg_color,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            height: "40px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Inter",
                              fontSize: "14px",
                              fontWeight: 600,
                              lineHeight: "20px",
                              letterSpacing: "0.1",
                              textAlign: "center",
                              color: "#17182C",
                              gap: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              textTransform: "none",
                              padding: "10px 0px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="18"
                              viewBox="0 0 19 18"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_7004_2614)">
                                <path
                                  d="M15.0125 7.53C14.7606 6.25329 14.0732 5.10364 13.0678 4.27743C12.0624 3.45122 10.8013 2.99971 9.5 3C7.3325 3 5.45 4.23 4.5125 6.03C3.41018 6.14912 2.39075 6.67141 1.65012 7.49649C0.909478 8.32158 0.499871 9.39126 0.5 10.5C0.5 12.9825 2.5175 15 5 15H14.75C16.82 15 18.5 13.32 18.5 11.25C18.5 9.27 16.9625 7.665 15.0125 7.53ZM14.75 13.5H5C3.3425 13.5 2 12.1575 2 10.5C2 8.9625 3.1475 7.68 4.67 7.5225L5.4725 7.44L5.8475 6.7275C6.19248 6.05614 6.71598 5.49296 7.36041 5.09996C8.00483 4.70695 8.74519 4.49935 9.5 4.5C11.465 4.5 13.16 5.895 13.5425 7.8225L13.7675 8.9475L14.915 9.03C15.4788 9.06792 16.0073 9.31799 16.3942 9.72989C16.781 10.1418 16.9975 10.6849 17 11.25C17 12.4875 15.9875 13.5 14.75 13.5ZM6.5 9.75H8.4125V12H10.5875V9.75H12.5L9.5 6.75L6.5 9.75Z"
                                  fill="black"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_7004_2614">
                                  <rect
                                    width="18"
                                    height="18"
                                    fill="white"
                                    transform="translate(0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <Box sx={{ margin: "0px", padding: "0px" }}>
                              Browse files
                            </Box>
                          </Typography>
                        </Box>
                      </Button>
                      <input
                        id="file-upload"
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "310px",
                      maxHeight: "144px",
                      marginTop: "20px", 
                      display:"flex",
                      flexDirection:"column",
                      justifyContent:"space-between"  
                    }}
                  >

                    <Box sx={{display:"flex", flexDirection:"column"}}>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        textAlign: "left",
                        color: "#ffffff",
                        textTransform: "none",
                        marginLeft: "20px",
                        marginBottom: "16px",
                      }}
                    >
                      {`Your File`}
                    </Typography>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "20px",
                          letterSpacing: "0.1px",
                          textAlign: "left",
                          color: "#CAC4D0",
                          textTransform: "none",
                          marginLeft: "20px",
                        }}
                      >
                        {file == null ? (
                          "You haven’t uploaded any file yet."
                        ) : (
                          <Box>
                            {fileName}
                          </Box>
                        )}
                      </Typography>
                    </Box>
                    </Box>

                    <Button onClick={HandleDownloadSampleFile} sx={{textTransform:"none", maxWidth:'210px', display:"flex", flexDirection:"row", columnGap:"10px", padding:"8px 12px", bgcolor:"#282D51", marginLeft:"20px"}}>
                    <SaveAltOutlinedIcon style={{ color: 'white' }} />
                    <Typography sx={{fontFamily:"Inter", fontSize:"14px", fontStyle:"normal", fontWeight:400, lineHeight:"19.6px", letterSpacing:"0.1px", color: 'white'}}>Download sample file</Typography>
                    </Button>
                        
                  </Box>
                </Box>
                <Box sx={{}}>
                  <Box sx={{ marginBottom: 3 }}>
                    <TextField
                      type="text"
                      // onChange={(e) => setWebSiteLink(e.target.value)}
                      value={contactId}
                      id="outlined-basic"
                      label="Contact ID (Column name)"
                      placeholder="phone"
                      variant="outlined"
                      sx={customTextFieldStyles(false)}
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "56px",
                        color: "#FFFFFF",
                        backgroundColor: "#232746",
                        borderRadius: "16px",
                        boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                        placeholderfontsize: "16px",
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ marginBottom: 3 }}>
                      <TextField
                        type="text"
                        onChange={(e) => setDelimiter(e.target.value)}
                        value={delimiter}
                        id="outlined-basic"
                        label="CSV File Delimiter"
                        placeholder="CSV File Delimiter"
                        variant="outlined"
                        sx={customTextFieldStyles(false)}
                        style={{
                          width: "270px",
                          maxWidth: "270px",
                          height: "56px",
                          color: "#FFFFFF",
                          backgroundColor: "#232746",
                          borderRadius: "16px",
                          boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                          placeholderfontsize: "16px",
                        }}
                      />
                    </Box>
                    <Box sx={{ marginBottom: 3 }}>
                      <TextField
                        type="text"
                        onChange={(e) => setBatchCount(e.target.value)}
                        value={batchCount}
                        id="outlined-basic"
                        label="Batch upload size"
                        placeholder="Batch upload size"
                        variant="outlined"
                        sx={customTextFieldStyles(false)}
                        style={{
                          width: "270px",
                          maxWidth: "270px",
                          height: "56px",
                          color: "#FFFFFF",
                          backgroundColor: "#232746",
                          borderRadius: "16px",
                          boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                          placeholderfontsize: "16px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "12px",
                }}
              >
                <FormControlLabel onClick={(e)=>{setInstantCall(!instantCall)}}
                  control={
                    <ToggleSwitch
                      sx={{ transform: "scale(0.8)" }}
                      checked={instantCall}
                    />
                  }
                  // label=""
                  // labelPlacement=""
                  sx={{
                    whiteSpace: "nowrap",
                    margin: 0, // Removes default margin
                    maxWidth: "100%", // Ensures it doesn't exceed the parent's width
                    display: "flex",
                    alignItems: "center",
                  }}
                />
                <Typography
                  id=""
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    font: "Inter",
                  }}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    color: theme === "dark" ? "#FFFFFF" : "",
                  }}
                >
                 Trigger calls to all uploaded contacts instantly
                </Typography>
                </Box>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.12)",
              p: 5,
            }}
          >
            <Button disabled={uploading || loading}
              variant="contained"
                onClick={window == 1  ? activeUserObject ? ()=>handleUpdateContact() : () => handleAddContact() : () => handleUpload()}
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                width: "100%",
                '&:disabled': {
                                backgroundColor: button_bg_color_for_New_Project
                              }
              }}
            >
            {
              loading ?  <CircularProgress sx={{width:"16px", height:"16px", color:"#17182C"}}/> 
              :
               window === 1 ? activeUserObject ? "Update Contact" :  "Add contact" : "Import contacts"
            }
            </Button>
          </Box>
        </Box>
      </Modal>
      <CommonToast 
          open={toastopen}
          onClose={handleToastClose}
          content={content}
          iconType={iconType}
          bgColor={"#282D51"}/>
    </div>
  );
};

export default ModalForContacts;

const ContactDescription = () => {
  const customTextFieldStylesForInvalid = () => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255, 255, 255, 0.80) ",
      },
    };
  };
  return (
    <div>
      <Box
        sx={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
          marginRight: "20px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            Attribute mapping
          </Typography>
          <Typography>
            Attribute name needs to be exact and is case sensitive.
            (format: "name": "description")
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "20px" }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            Use default attribute mapping
          </Typography>

          <Box
            sx={{
              marginBottom: 0,
              border: "1px solid rgba(255, 255, 255, 0.20)",
              minHeight: "120px",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Typography>
              {`${"ekoe_ai_name : Name of the Contact , ekoeai_email : Email of the contact , ekoeai_phone : Phone number of the contact"}`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

const ContactSettings = () => {
  const customTextFieldStylesForInvalid = () => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  return (
    <div>
      <Box
        sx={{
          marginTop: "40px",
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
          marginRight: "40px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
          <Box sx={{ marginBottom: 3 }}>
            <TextField
              type="Contact ID"
              // onChange={(e) => setWebSiteLink(e.target.value)}
              //   onChange={(e) => {setWebSiteLinkError(false); setWebSiteLink(e.target.value); }}
              //   value={websitelink}
              id="outlined-basic"
              label="Contact ID"
              placeholder="Enter Contact ID"
              variant="outlined"
              sx={customTextFieldStyles(false)}
              // sx={{...customTextFieldStyles(false),mt:5}}
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "56px",
                color: "#FFFFFF",
                backgroundColor: "#232746",
                borderRadius: "16px",
                boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                placeholderfontsize: "16px",
              }}
            />
            <FormHelperText
              sx={{
                color:
                  "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "16px",
                margin: "4px 0px 0px 16px",
                alignSelf: "start",
              }}
            >
              {`The column name of the contact ID. This value must be unique for each contact.`}
            </FormHelperText>
          </Box>

          <Box sx={{ marginBottom: 3 }}>
            <TextField
              type="text"
              //   onChange={(e) => {setWebSiteLinkError(false); setWebSiteLink(e.target.value); }}
              //   value={websitelink}
              id="outlined-basic"
              label="Name"
              placeholder="Enter column name of contact name"
              variant="outlined"
              sx={customTextFieldStyles(false)}
              // sx={{...customTextFieldStyles(false),mt:5}}
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "56px",
                color: "#FFFFFF",
                backgroundColor: "#232746",
                borderRadius: "8px",
                boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                placeholderfontsize: "16px",
              }}
            />
            <FormHelperText
              sx={{
                color:
                  "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "16px",
                margin: "4px 0px 0px 16px",
                alignSelf: "start",
              }}
            >
              {`The column name of the contact name.`}
            </FormHelperText>
          </Box>

          <Box sx={{ marginBottom: 3 }}>
            <TextField
              type="Phone number"
              // onChange={(e) => setWebSiteLink(e.target.value)}
              //   onChange={(e) => {setWebSiteLinkError(false); setWebSiteLink(e.target.value); }}
              //   value={websitelink}
              id="outlined-basic"
              label="Phone number"
              placeholder="Enter column name of contact phone number"
              variant="outlined"
              sx={customTextFieldStyles(false)}
              // sx={{...customTextFieldStyles(false),mt:5}}
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "56px",
                color: "#FFFFFF",
                backgroundColor: "#232746",
                borderRadius: "8px",
                boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                placeholderfontsize: "16px",
              }}
            />
            <FormHelperText
              sx={{
                color:
                  "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "16px",
                margin: "4px 0px 0px 16px",
                alignSelf: "start",
              }}
            >
              {`The column name of the contact phone number.`}
            </FormHelperText>
          </Box>

          <Box sx={{ marginBottom: 3 }}>
            <TextField
              type="Email (optional)"
              // onChange={(e) => setWebSiteLink(e.target.value)}
              //   onChange={(e) => {setWebSiteLinkError(false); setWebSiteLink(e.target.value); }}
              //   value={websitelink}
              id="outlined-basic"
              label="Email (optional)"
              placeholder="Enter column name of contact email"
              variant="outlined"
              sx={customTextFieldStyles(false)}
              // sx={{...customTextFieldStyles(false),mt:5}}
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "56px",
                color: "#FFFFFF",
                backgroundColor: "#232746",
                borderRadius: "8px",
                boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                placeholderfontsize: "16px",
              }}
            />
            <FormHelperText
              sx={{
                color:
                  "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "16px",
                margin: "4px 0px 0px 16px",
                alignSelf: "start",
              }}
            >
              {`The column name of the contact email.`}
            </FormHelperText>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export const ModalForContactSetup = ({
  showContactSetupModal,
  handleClose,
}) => {
  const theme = localStorage.getItem("theme");
  const [activeTab, setActiveTab] = useState("Description");

  const renderContent = () => {
    switch (activeTab) {
      case "Description":
        return <ContactDescription />;
      case "Settings":
        return <ContactSettings />;
      default:
        return <ContactDescription />;
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      <Modal
        open={showContactSetupModal}
        onClose={handleClose}
        aria-labelledby="image-settings-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "900px",
            height: "636px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            // p: 4,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
          }}
        >
          <Typography
            id=""
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // mb: 2,
              borderBottom: `1px solid ${theme === "dark" ? "#535774" : ""}`,
              padding: "20px",
              fontFamily: "Inter, sans-serif",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            Contact Setup
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={activeTab}
              onChange={(event, newValue) => setActiveTab(newValue)}
              sx={{
                borderRight: 1,
                borderColor: theme === "dark" ? "#535774" : "",
                minWidth: "150px",
                display: "flex",
                flexDirection: "column",
                width: "223px",
              }}
              TabIndicatorProps={{
                style: {
                  display: "none", // Hide the default indicator (blue underline)
                },
              }}
            >
              <Tab
                label="Contact Description"
                value="Description"
                sx={{
                  backgroundColor:
                    activeTab === "Description"
                      ? selecetedSettings_Nav_bg_dm
                      : "transparent", // Grey background for selected tab
                  "&:hover": {
                    backgroundColor:
                      theme === "dark" ? hoveredSettings_Nav_bg_dm : "", // Light grey on hover
                  },
                  color: theme === "dark" ? "white" : "black",
                  textTransform: "none",
                  fontSize: "14px",
                  margin: "20px 20px 4px 20px",
                  borderRadius: "8px",
                }}
                style={{ color: "#FFFF" }}
              />
              <Tab
                label="Contact Settings"
                value="Settings"
                sx={{
                  backgroundColor:
                    activeTab === "Settings"
                      ? selecetedSettings_Nav_bg_dm
                      : "transparent", // Grey background for selected tab
                  "&:hover": {
                    backgroundColor:
                      theme === "dark" ? hoveredSettings_Nav_bg_dm : "", // Light grey on hover
                  },
                  color: theme === "dark" ? "white" : "black",
                  textTransform: "none",
                  fontSize: "14px",
                  margin: "0 20px 4px 20px",
                  borderRadius: "8px",
                }}
                style={{ color: "#FFFF" }}
              />
            </Tabs>
            <Box
              sx={{
                flexGrow: 1,
                pl: 3,
                overflowY: "auto",
                maxHeight: "504px",
                width: "504px",
              }}
            >
              {renderContent()}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // mt: 2,
              p: 2,
              borderTop: `1px solid ${theme === "dark" ? "#444" : "#ccc"}`, // Border top added
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                mr: 1,
                backgroundColor:
                  theme === "dark" ? uploadFiles_button_default_bg_color : "",
                "&:hover": {
                  backgroundColor: uploadFiles_button_hovered_bg_color,
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={
                activeTab === "Description"
                  ? (event) => {
                    handleTabChange(event, "Settings");
                  }
                  : (event) => {
                    handleTabChange(event, "Description");
                  }
              }
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
              }}
            >
              {activeTab === "Description" ? "Save and next" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

